export default __webpack_public_path__ + "static/media/kinder6.0c1d3ca7.png";